import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Tooltip = _resolveComponent("Tooltip")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["ellipsis", {multiple: $props.lines > 1}]),
    onMouseover: _cache[0] || (_cache[0] = _withModifiers((...args) => ($options.onHover && $options.onHover(...args)), ["stop"]))
  }, [
    _createVNode(_component_Tooltip, {
      "disable-tooltip": !$data.show_tip,
      text: $props.text || $options.getSlotText(),
      placement: $props.tooltipPlacement,
      teleported: $props.teleported,
      "max-width": $props.maxWidth
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", null, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(_toDisplayString($props.text), 1 /* TEXT */)
          ], true)
        ])
      ]),
      _: 3 /* FORWARDED */
    }, 8 /* PROPS */, ["disable-tooltip", "text", "placement", "teleported", "max-width"])
  ], 34 /* CLASS, NEED_HYDRATION */))
}